// extracted by mini-css-extract-plugin
export default {"header":"NotificationList_header__f3C1s","shareApp":"NotificationList_shareApp__0uqar"};